// extracted by mini-css-extract-plugin
export var actions = "_us-4";
export var item = "_us-1";
export var price = "_us-3";
export var quantity = "_us-2";
export var table = "_us-0";